import { queryParse } from 'growth-swiss-knife/utils';

const { href, search, pathname } = window.location;

const UTM_QUERY_PARAMS = queryParse(search).filter(({ name }) => name.indexOf('utm_') === 0);
const UTM_SOURCE_EXPLICIT = queryParse(search).find(({ name }) => name.indexOf('utm_source') === 0) === undefined
        ? [{ name: 'utm_source', value: 'landing_page' }]
        : [];
const LANDING_PAGE = { name: 'landing_page', value: encodeURI(href) };
// TODO(Remove when GROW-3130 experiment is done)
const CMB_CTA_EXPERIMENT = pathname === '/' ? [{ name: 'cmb_cta', value: 'not_gv' }] : [];

export default [
    ...UTM_QUERY_PARAMS,
    ...UTM_SOURCE_EXPLICIT,
    LANDING_PAGE,
    ...CMB_CTA_EXPERIMENT,
];
